import Vue from "vue";
import Vuex from "vuex";

import achievements from "./achievements";
import documents from "./documents";
import notes from "./notes";
import profiles from "./profiles";
import resources from "./resources";
import users from "./users";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    achievements,
    documents,
    notes,
    profiles,
    resources,
    users
  }
});
